import React from 'react';
import { useFilterContext } from '../../context/aptmetrix/FilterContext';
import { useTooltip } from './useTooltip';
import FilterButton from './FilterButton';
import TooltipShell, { FilterActions } from './TooltipShell';

const SchoolFilter = ({ isOpen, onToggle, onClose, selectedRegion, data, onFilterChange }) => {
    const {
        filterUIState,
        setFilterUIState,
        setSchoolFilter,
    } = useFilterContext();

    const { hasSchool, isSchoolFilterActive } = filterUIState;

    const { tooltipRef, buttonRef } = useTooltip(isOpen, onClose);

    const updateUI = (updates) => setFilterUIState(prev => ({ ...prev, ...updates }));

    const handleToggle = () => {
        if (!selectedRegion) {
            alert('지역을 먼저 선택하세요');
            return;
        }
        onToggle();
    };

    const apply = () => {
        updateUI({ isSchoolFilterActive: true });
        setSchoolFilter(hasSchool);
        onFilterChange({ hasSchool });
        onClose();
    };

    const reset = () => {
        updateUI({ hasSchool: true, isSchoolFilterActive: false });
        onFilterChange(null);
        onClose();
    };

    const isDisabled = !data || data.length === 0;

    const getActiveLabel = () => hasSchool ? '초등학교O' : '초등학교X';

    return (
        <div className="relative">
            <FilterButton
                ref={buttonRef}
                label="초등학교"
                activeLabel={getActiveLabel()}
                isActive={isSchoolFilterActive}
                isDisabled={isDisabled}
                onClick={handleToggle}
            />
            {isOpen && (
                <TooltipShell ref={tooltipRef} title="초등학교 필터" onClose={onClose}>
                    <div className="mb-3">
                        <h4 className="text-sm font-medium mb-2">초등학교 유무</h4>
                        <div className="flex gap-2">
                            <button
                                onClick={() => updateUI({ hasSchool: true })}
                                className={`flex-1 p-1 text-xs rounded-full ${
                                    hasSchool === true
                                        ? 'bg-blue-500 text-white'
                                        : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                                }`}
                            >
                                초등학교 있음
                            </button>
                            <button
                                onClick={() => updateUI({ hasSchool: false })}
                                className={`flex-1 p-1 text-xs rounded-full ${
                                    hasSchool === false
                                        ? 'bg-blue-500 text-white'
                                        : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                                }`}
                            >
                                초등학교 없음
                            </button>
                        </div>
                    </div>
                    <FilterActions onReset={reset} onApply={apply} />
                </TooltipShell>
            )}
        </div>
    );
};

export default SchoolFilter;
